import React from 'react';
import { Instagram, Facebook, Linkedin, Youtube } from 'lucide-react';
import { SOCIAL_LINKS, officialSocialUrl } from '@/lib/socialLinks';
const networks = [['instagram', 'Instagram', Instagram], ['facebook', 'Facebook', Facebook], ['linkedin', 'LinkedIn', Linkedin], ['youtube', 'YouTube', Youtube]];
export default function SocialLinks({ it }) {
  const available = networks.filter(([key]) => officialSocialUrl(SOCIAL_LINKS[key]));
  if (!available.length) return null;
  return <div className="mt-6"><div className="flex gap-2" aria-label={it ? 'Profili social PlantAdopting' : 'PlantAdopting social profiles'}>
    {available.map(([key, label, Icon]) => { const href = officialSocialUrl(SOCIAL_LINKS[key]);
      const style = 'inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#E3B24C]/50';
      return <a key={key} href={href} target="_blank" rel="noopener noreferrer" aria-label={`${label} — PlantAdopting`} className={`${style} hover:bg-[#E3B24C] hover:text-[#3A4A30] focus-visible:outline focus-visible:outline-2`}><Icon size={18} aria-hidden="true" /></a>;
    })}</div></div>;
}

